import { createFileRoute } from "@tanstack/react-router";
import { CredentialDomainsPage } from "@/features/operator/CredentialDomainsPage";

export const Route = createFileRoute("/app/operator/credential-domains")({
  component: CredentialDomainsPage,
});
